import { commentsItems } from '@/mocks/homepage';

export default function CommentsSection() {
  return (
    <section id="comments" className="relative w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">观众心声</h2>
          <p className="text-sm text-foreground-600">来自春夜观众的真实分享</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 max-w-5xl mx-auto">
          {commentsItems.map((comment) => (
            <div key={comment.id} className="p-5 md:p-6 rounded-xl bg-background-50 flex gap-4">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 rounded-full overflow-hidden">
                  <img src={comment.avatar} alt={comment.name} className="w-full h-full object-cover" />
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-2 flex-wrap gap-2">
                  <h3 className="text-sm font-medium text-foreground-950">{comment.name}</h3>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{comment.time}</span>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{comment.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}